<div class="p-16" *ngFor="let num of numSequence(count)">
  <div class="row justify-start items-center pb-8">
    <app-skeleton-loader [width]="_avatarWidth" [height]="_avatarHeight" [circle]="isCircle"></app-skeleton-loader>
    <div class="pl-8 flex-1">
      <app-skeleton-loader width="30%" [height]="_titleHeight" className="mb-4"></app-skeleton-loader>
      <app-skeleton-loader width="100%" [height]="_titleHeight" className="mb-4"></app-skeleton-loader>
    </div>
  </div>
  <div class="ml-8 pl-16 not-bb-last">
    <div class="row justify-between py-4 bb-1">
      <app-skeleton-loader [width]="_titleWidth" [height]="_titleHeight" className="mb-4"></app-skeleton-loader>
    </div>
    <div class="row justify-between py-4 bb-1">
      <app-skeleton-loader [width]="_titleWidth" [height]="_titleHeight" className="mb-4"></app-skeleton-loader>
    </div>
  </div>
</div>
